export default [
    {
      path: '/admin/reports/finances/cash-collect-by-cashiers',
      name: 'cash-collection-by-cashier',
      meta: { requiresAuth: true },
      component: () => import('@/pages/report/finance/cash-collection-by-cashier.vue')
    }
  ]
